import React from "react";
import "./css/LandingPage-FAQ.css";

function LandingPage_FAQ() {
  const faqs = [
    {
      question: "Who is KinShield™ for?",
      answer:
        "Anyone vulnerable to online scams — families, elderly parents, even tech-savvy young adults.",
    },
    {
      question: "How does text/email scam-detection work?",
      answer:
        "You forward suspicious texts/emails to our secure service. We analyze them using AI and return a risk assessment.",
    },
    {
      question: "How does the simulation work?",
      answer:
        "We mimic real-world attacks like phishing, smishing, or social engineering based on your choices. It is a simulation, no real data is compromised. Your data privacy is our priority.",
    },
    {
      question: "What happens after a simulation?",
      answer:
        "Users receive instant feedback, tips, and can view their performance in a gamified report.",
    },
    {
      question: "Is this tool easy to use for non-tech-savvy individuals?",
      answer: "Yes, our interface is designed for simplicity and ease of use.",
    },
    {
      question: "Can I customize the simulations?",
      answer:
        "Yes, you can customize the frequency, types of scams, and difficulty level.",
    },
    {
      question: "Is my family's data secure?",
      answer:
        "We prioritize data privacy and security, using robust encryption and industry best practices.",
    },
    {
      question: "What subscription plans are available?",
      answer:
        "We offer Individual, Family/Group, and Extended Family plans with flexible pricing to suit your needs. Visit our pricing page for detailed information.",
    },
  ];

  const scrollToTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    document.documentElement.scrollTop = 0;
  };

  return (
    <main className="landing-main40">
      <div className="scroll-to-top-link" onClick={scrollToTop}>
        Top ↑
      </div>
      <div className="landing-page40">
        <h2 className="landing-page40-title">Frequently Asked Questions</h2>
        <div className="faq-container">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-card">
              <h3 className="faq-question">{faq.question}</h3>
              <p className="faq-answer">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
}

export default LandingPage_FAQ;
